import React from 'react';
import { Tooltip } from '@chakra-ui/react';
import { AdminDashboardDataDaysInterface } from '../../../../shared/type/administrator.type';
import { useThemeContext } from '../../../../context/ThemeProvider';

export interface DayCellProps {
  date: Date;
  dayCount?: AdminDashboardDataDaysInterface;
  isTenantHasAccessToOrders?: boolean;
}

export const DayCell: React.FC<DayCellProps> = ({ date, dayCount, isTenantHasAccessToOrders }) => {
  const { isMobile } = useThemeContext();
  const isDisabled = !isTenantHasAccessToOrders;

  const CellContent = isDisabled ? (
    <Tooltip
      hasArrow
      label={isDisabled ? 'Brak dostępu do zamówień' : ''}
      placement="top"
      bg="#ececed"
      rounded="8px"
      padding="12px"
      color="black">
      <div className="xs:text-sm lg:text-lg">{date.getDate()}</div>
      {!isMobile && (
        <div className="w-24 flex flex-col items-start justify-end overflow-hidden">
          <p className="font-bold text-xs lg:text-sm mb-1 text-ellipsis text-nowrap">
            {dayCount?.toDistribute || 0} do wydania
          </p>
          <p className="text-xs lg:text-sm mb-1 text-ellipsis text-nowrap">
            {dayCount?.absences || 0} nieobecności
          </p>
          <p className="text-xs lg:text-sm text-ellipsis text-nowrap">
            {dayCount?.totalCount || 0} zamówienia
          </p>
        </div>
      )}
    </Tooltip>
  ) : (
    <>
      <div className="xs:text-sm lg:text-lg">{date.getDate()}</div>
      {!isMobile && (
        <div className="w-24 flex flex-col items-start justify-end overflow-hidden">
          <p className="font-bold text-xs lg:text-sm mb-1 text-ellipsis text-nowrap">
            {dayCount?.toDistribute || 0} do wydania
          </p>
          <p className="text-xs lg:text-sm mb-1 text-ellipsis text-nowrap">
            {dayCount?.absences || 0} nieobecności
          </p>
          <p className="text-xs lg:text-sm text-ellipsis text-nowrap">
            {dayCount?.totalCount || 0} zamówienia
          </p>
        </div>
      )}
    </>
  );
  return (
    <div
      className={`custom-day-cell z-0 p-1 pr-1 lg:p-2 lg:pr-4 ${isDisabled ? 'opacity-50 cursor-not-allowed' : ''}`}
      style={{
        minHeight: '100px'
      }}>
      {CellContent}
    </div>
  );
};
